import { ActionBar, ButtonVariant } from '@dreryk/react-components';
import { useDraftRemoveByTokenCqrsCommand } from '@dreryk/react-draft';

import { getReferralDraftToken } from '../../referral.draft';
import { referralTranslationKeys } from '../../translations';
import { ReferralToHospitalFormController } from '../ReferralToHsopitalForm/ReferralToHospitalForm.types';

import { useReferralToHospitalConfirmAndPrintCommand } from './ReferralToHospitalSendAction.hooks';

type ReferralToHospitalSendActionProps = {
   readonly handleSubmit: ReferralToHospitalFormController['handleSubmit'];
   readonly visitId: number;
   readonly onSuccess: VoidFunction;
};

export const ReferralToHospitalSendAction = (props: ReferralToHospitalSendActionProps): JSX.Element => {
   const { executeAsync: removeDraft } = useDraftRemoveByTokenCqrsCommand();
   const { executeAsync: sendReferralToHospital } = useReferralToHospitalConfirmAndPrintCommand(
      props.visitId,
      async () => {
         props.onSuccess();
         await removeDraft({ token: getReferralDraftToken('referralToHospital', props.visitId) });
      }
   );
   return (
      <ActionBar.PrimaryButton
         variant={ButtonVariant.PRIMARY}
         onClick={props.handleSubmit(sendReferralToHospital)}
         label={referralTranslationKeys.actionBar.confirmAndPrint}
         testId={'confirmAndPrint'}
         blockingOperation
      />
   );
};
